import { SubmittingUser } from '@servicetitan/financing-api-client';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

function useSubmittingUser(initialState?: SubmittingUser) {
    const [submittingUser, setSubmittingUser] = useState<SubmittingUser>(
        initialState ?? {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
        },
    );

    return {
        submittingUser,
        setSubmittingUser,
    };
}

export const SubmittingUserStore = createStore(useSubmittingUser);

export type SubmittingUserStore = ReturnType<typeof useSubmittingUser>;
